import styled from 'styled-components';

export const NotifierContainer = styled.div`
  position: fixed;
  top: 80px;
  right: 0;
  z-index: 9999;
  width: 500px;
  transform: scale(0.8);
  transform-origin: right top;
`;
